module.exports = __webpack_public_path__ + "img/down_arrow.6ec3fa54.svg";